import { statusColorTransitionClass } from './utils/statusPill';

export default defineAppConfig({
  ui: {
    badge: {
      slots: {
        base: statusColorTransitionClass,
      },
    },
    colors: {
      primary: 'sky',
      neutral: 'gray',
    },
  },
});
